import styled from 'styled-components'

export const DropdownSummaryWrapper = styled.div`
  width: 100%;
  margin: 0;
  pointer-events: none;
  button {
    background: transparent;
  }
  span,
  svg[width='16'] {
    display: none;
  }
`
